module.exports = __webpack_public_path__ + "images/template-create-popover-icon.9031d6f24be0b85716f8.svg";